import config from './_config'
import { Contents } from './types'
import { useMutation } from '../../internal'

const useBoostContent = (contentId) => {
  const mutation = useMutation()

  return mutation<never, Contents.Boost>({
    method: 'POST',
    endpoint: config?.endpoints.boost(contentId)
  })
}

export default useBoostContent
